<template>
	<div id="reset-password-template">
		<div class="container">
			<div class="reset-password-form">
				<input type="text" v-model="resetToken" placeholder="verification code">
				<input type="password" v-model="password" placeholder="new password">
				<input type="password" v-model="confirmPassword" placeholder="confirm new password">
				<button class="btn" @keyup.enter="resetPassword" @click="resetPassword">Reset password</button>
			</div>
		</div>
	</div>
</template>

<script>

// import CreateProgressBar from '../common/Create/CreateProgressBar';
// import LoginPanel from '../common/Login/LoginPanel';


export default {
	data(){
		return {
			resetToken : "",
			password : "",
			confirmPassword : ""
		}
	},
	methods : {
		resetPassword(){

			let message = "";

			if(!this.resetToken){message = "you must supply a reset token";}
			if(!this.password){message = "you must provide an password";}
			if(!this.confirmPassword){message = "you must confirm your password";}
			if(this.confirmPassword !== this.password){message = "your passwords must match";}
			if(this.password.length <= 10){message = "your password should be 10 characters or longer";}

			if(message.length){
				this.$toasted.error(message, {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 4000
                })
                return;
            }

            let formData = {
            	resetToken : this.resetToken,
            	password : this.password
            }

            this.$toasted.show("Please wait...", {
                theme: 'bubble',
                position: 'bottom-center',
                duration: null
            })

            this.$store.dispatch('userResetPasswordConfirm', formData)
            .then((response) => {
            	this.$toasted.clear();
            	if(response.confirmation === 'fail' || response.confirmation === 'validation'){
            		this.$toasted.error(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 4000
		            })
		            return;
            	} 

            	if(response.confirmation === 'success'){
						this.$toasted.success(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 4000
		            });
					this.$router.push({path : '/login'})

		            return;

				
			
            	}
            })
            .catch((err) => {
            	this.$toasted.clear();
            	this.$toasted.error(err.message, {
		            theme: 'bubble',
		            position: 'bottom-center',
		            duration: 4000
		        })
		        return;
            })
		}
	},
	created(){
		if(this.$route.query.resetToken){
			this.resetToken = this.$route.query.resetToken;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ResetPassword.vue